import { CBDropdown } from '@cb/apricot';
/* eslint-disable jsx-a11y/anchor-is-valid */

/* {
  useApricotDropdown: boolean
  items: [{ label: string/component, action: function }]
  className: string,
  id: string,
  label: string/component
} */

function Dropdown(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$useApricotDropdo = _ref.useApricotDropdown,
    useApricotDropdown = _ref$useApricotDropdo === void 0 ? true : _ref$useApricotDropdo,
    className = _ref.className,
    label = _ref.label,
    id = _ref.id,
    alignDropdownRight = _ref.alignDropdownRight,
    triggerDisplaysAsCurrentSelection = _ref.triggerDisplaysAsCurrentSelection,
    _ref$light = _ref.light,
    light = _ref$light === void 0 ? false : _ref$light;
  var dropdownRef = useRef(null);
  var itemLength = items.length;
  var dropdownId = "dropdownMenu".concat(id);
  useEffect(function () {
    if (itemLength > 1) {
      CBDropdown({
        elem: dropdownRef.current,
        closeOnClick: true
      });
    }
  }, [itemLength]);
  if (!itemLength) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(useApricotDropdown ? 'cb-dropdown' : '', " ").concat(className || ''),
    ref: dropdownRef
  }, itemLength === 1 ? /*#__PURE__*/React.createElement("span", {
    style: {
      color: light ? '#fff' : 'inherit'
    }
  }, items[0].label) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: "cb-dropdown-toggle",
    href: "#",
    id: dropdownId,
    role: "button",
    "aria-expanded": false,
    "aria-haspopup": true,
    "aria-controls": "".concat(dropdownId, "Menu"),
    "aria-current": triggerDisplaysAsCurrentSelection
  }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Press Enter for Dropdown."), /*#__PURE__*/React.createElement("i", {
    className: "cb-icon cb-down",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("i", {
    className: "cb-icon cb-up cb-hidden",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-dropdown-menu cb-box-shadow"
  }, /*#__PURE__*/React.createElement("ul", {
    id: "".concat(dropdownId, "Menu"),
    className: "".concat(alignDropdownRight ? 'dropdown-menu-right' : '', " dropdown-menu"),
    role: "menu",
    "aria-labelledby": dropdownId
  }, items.map(function (item, i) {
    return /*#__PURE__*/React.createElement("li", {
      role: "presentation",
      key: i
    }, /*#__PURE__*/React.createElement("a", {
      role: "menuitem",
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        item.action(e);
      }
    }, item.label));
  })))));
}
export default Dropdown;